import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/admin/AuthContext";

export default function ProtectedRoute({ children, requireAdmin = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <main className="min-h-screen grid place-items-center bg-[#F5FAFB]">
        <Loader2 size={20} className="animate-spin text-[#7D8188]" />
      </main>
    );
  }

  if (!user) {
    return (
      <Navigate
        to="/admin/login"
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  if (requireAdmin && user.role !== "admin") {
    return <Navigate to="/admin" replace />;
  }

  // visitors (logged-in users without partner/admin role) are kept on /admin
  // to see a friendly "no permission" screen handled by the dashboard.
  return children;
}
